import Card from "@material-ui/core/Card";
import Container from "@saleor/components/Container";
import { RiderDispatchBatch_riderDispatchBatch } from "@saleor/dispatch/types/RiderDispatchBatch";
import { UseNavigatorResult } from "@saleor/hooks/useNavigator";
import * as React from "react";

import TripInformationList from "../TripInformationList";
import PageHeader from "./components/PageHeader";

interface TripInformationDetailsPageProps {
  onBack: () => void;
  tripInformation: RiderDispatchBatch_riderDispatchBatch;
  loading: boolean;
  navigate: UseNavigatorResult;
  navigateUrl: (id: string) => string;
  generateTripTicket: () => void;
}

const TripInformationDetailsPage: React.FC<TripInformationDetailsPageProps> = props => {
  const {
    onBack,
    tripInformation,
    loading,
    navigate,
    navigateUrl,
    generateTripTicket
  } = props;

  return (
    <Container>
      <PageHeader
        onBack={onBack}
        tripInformation={tripInformation}
        loading={loading}
        generateTripTicket={generateTripTicket}
      />
      <Card>
        <TripInformationList
          tripInformation={tripInformation}
          loading={loading}
          navigate={navigate}
          navigateUrl={navigateUrl}
        />
      </Card>
    </Container>
  );
};

export default TripInformationDetailsPage;
